import React, { useState, useEffect } from 'react';
import CardBought from './CardBought';

import styles from '../Rewards.module.scss';
import cx from 'classnames';

const CardHolder = ({ card, userCard, i, selectedPack }) => {

    const [flipAnimation, setFlipAnimation] = useState(false);
    const [flipCard, setFlipCard] = useState();

    useEffect(() => {
        if (flipAnimation) {
            setTimeout(() => {
                setFlipCard(true);
            }, 100)
        }
    }, [flipAnimation, setFlipCard])

    return (
        <>
            {
                userCard && (
                    <div className={styles.rewardsItem}>
                        <div className={cx(styles.flipCard, { [styles.flipCardFlipped]: flipCard })}>
                            <div className={styles.flipCardInner}>
                                <div className={cx({ [styles.flipCardBack]: flipAnimation })}>
                                    <CardBought i={i} card={card} print={true} selectedPack={selectedPack} />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default CardHolder;